import { jsx } from "react/jsx-runtime";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { validateTidalLicense } from "../../base/index.js";
function InsertDriveFileOutlined(props) {
  return /* @__PURE__ */ jsx(
    InsertDriveFileOutlinedIcon,
    {
      "data-testid": "InsertDriveFileOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "InsertDriveFileOutlined",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
InsertDriveFileOutlined.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "InsertDriveFileOutlined"
};
validateTidalLicense();
export {
  InsertDriveFileOutlined
};
//# sourceMappingURL=InsertDriveFileOutlined.js.map
